import { render, staticRenderFns } from "./WineView.vue?vue&type=template&id=f87c8c68"
import script from "./WineView.vue?vue&type=script&lang=ts"
export * from "./WineView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports